/* V13 (06.10.2026) · Kopfzeile: misst, ob die Navigation dem Logo zu nahe kommt, und schaltet Stufen.
   Siehe hl-v13.css. Ohne dieses Skript bleibt die Kopfzeile wie in V12. */
(function () {
  'use strict';
  var group = document.querySelector('.hl-header-group');
  if (!group) return;
  var mq = window.matchMedia('(min-width: 990px)');
  var MIN_GAP = 16;
  var queued = false;
  var cl = group.classList;

  function itemsOf(root) {
    var out = [];
    var kids = root.children;
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k.classList.contains('hl-header__nav')) {
        for (var j = 0; j < k.children.length; j++) out.push(k.children[j]);
      } else if (k.offsetWidth > 0) {
        out.push(k);
      }
    }
    return out;
  }

  function overflows() {
    var logo = group.querySelector('.hl-header__logo');
    var start = group.querySelector('.hl-header__nav-wrap');
    var end = group.querySelector('.hl-header__actions');
    if (!logo || !start || !end) return false;
    var lr = logo.getBoundingClientRect();
    var maxRight = -Infinity;
    var minLeft = Infinity;
    itemsOf(start).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width > 0) maxRight = Math.max(maxRight, r.right);
    });
    itemsOf(end).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width > 0) minLeft = Math.min(minLeft, r.left);
    });
    return (isFinite(maxRight) && maxRight > lr.left - MIN_GAP) ||
           (isFinite(minLeft) && minLeft < lr.right + MIN_GAP);
  }

  function apply() {
    queued = false;
    cl.remove('hl-header--tight', 'hl-header--burger', 'hl-header--icons');
    if (!mq.matches) return;
    if (!overflows()) return;
    cl.add('hl-header--tight');
    if (!overflows()) return;
    cl.add('hl-header--burger');
    if (!overflows()) return;
    cl.add('hl-header--icons');
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(apply);
  }

  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
  if (mq.addEventListener) mq.addEventListener('change', queue);
  else if (mq.addListener) mq.addListener(queue);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
  apply();
})();
